module.exports = "https://cdn.realtymogul.com/static/media/social_linkedin_gray.6ccf1bf2.svg";